import { request } from "graphql-request";  
import { getToken } from "./helpers";
import { pageQuery } from "../server/helpers/pageQuery";
import logger from "./logger";

export async function fetchReplaysData(variables, url) {
  try {
    const token = await getToken();  // Await for token fetch
    const headers = {
      authorization: token,
    };
    const res = await request(url, pageQuery, variables, headers);  // Await for the request to resolve
    return res;
  } catch (err) {
    logger(`Error in fetching replays data ${err}`, "error");
    return undefined;  // Return undefined when an error occurs
  }
}
